





























































































































































































































import {Emit} from 'vue-property-decorator';
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {ResultType} from '@/shared/xhttp';
import storeUpload from "@/stores/modules/upload";
import {ObjectString} from "gollumts-objecttype";
import {Organisation, Upload} from "@/models";
import storeNotifier, {NotifyInterface} from "@/stores/modules/notifier";
import {Form} from "@/shared/form";
import storeOrganisation from "@/stores/modules/organisateur";
import InputPhone from '@/components/Input/Phone.vue';

@Component({
	components: {
		InputPhone,
	}
})
export default class OrganisationView extends Vue {

	@Stored(() => storeUpload) private progresses: ObjectString<number>;

	private item: Organisation = null;
	private form: Form = new Form();
	protected mainForm: Form = new Form();
	protected secondForm: Form = new Form();
	private file: File = null;
	private upload: Upload = null;
	public acceptedType = ['image/jpeg', 'image/png', 'image/webp', 'image/svg+xml']
	private apiUrl = process.env.VUE_APP_BACK_BASE_URL;
	private loading = true;
	private saveDisabled = false;

	public async mounted() {
		try {
			await storeOrganisation.dispatch('getC')
			this.item = storeOrganisation.state.organisations.data[0]
			this.loading = false
		} catch (e) {
			return this.loading = false
		}
	}

	public async refresh() {
		await storeOrganisation.dispatch('getC')
		this.item = storeOrganisation.state.organisations.data[0]
		this.$forceUpdate()
	}

	private async onSubmit() {
		this.saveDisabled = true;
		await storeOrganisation.dispatch('put', this.item)
		this.item = storeOrganisation.state.organisation
		await storeNotifier.dispatch('notify', {
			type: 'success',
			message: 'Organisation modifié'
		} as NotifyInterface);
		this.saveDisabled = false;
	}

	private async send(): Promise<void> {
		if (this.file) {
			if (!this.acceptedType.includes(this.file.type)) {
				return storeNotifier.dispatch('notify', {
					type: 'error',
					message: 'Format du fichier incorrect (format accepté: jpg, png, webp, svg)'
				} as NotifyInterface);
			}
			await this.form.call(async () => {
				this.upload = await storeUpload.dispatch('postLogo', { file: this.file });
				this.upload = await storeUpload.dispatch('waitFinish', this.upload);
				await storeNotifier.dispatch('notify', {
					type: 'success',
					message: 'Logo changé'
				} as NotifyInterface);
			});
			this.file = null;
			await this.refresh();
		}
	}


	private get show(): boolean {
		return this.upload && typeof this.progresses[this.upload.uuid] !== 'undefined';
	}

	private get progressValue(): number {
		return this.progresses[this.upload.uuid] ? this.progresses[this.upload.uuid] : 0;
	}

	private async createOrga() {
		let organisation = new Organisation()
		organisation.id = 1
		organisation.capital = 0
		organisation.name = 'Nom Organisation'
		storeOrganisation.dispatch('post', organisation)
		await this.refresh();
	}

}
